<template>
  <div class="col mb-3">
    <label :for="inputId" v-text="input.label"/>
    <input
        v-if="input.type !== 'select'"
        v-bind="inputAttributes"
        :type="input.type"
        :id="inputId"
        v-model="inputValue"
        @input="$emit('input-changed', input, inputValue)"
    >
    <select
        v-if="input.type === 'select'"
        v-bind="inputAttributes"
        :id="inputId"
        v-model="inputValue"
        @change="$emit('input-changed', input, inputValue)"
    >
      <option value="" v-if="input.includeBlank"/>
      <option
          v-for="option in input.options"
          :value="option.value"
          :selected="inputValue === option.value"
          v-text="option.label"
      />
    </select>
    <input type="hidden"
           :name="inputName"
           :value="inputValue"
           :disabled="disabled">
    <div v-if="!!input.errors" class="invalid-feedback" v-text="input.errors"></div>
    <small v-if="input.help" class="text-muted" v-text="input.help"/>
  </div>
</template>
<script>
export class InputProps {
  constructor({type='text', attribute, value, help, label, errors=null, html={}, options, include_blank=true}) {
    this.type = type
    this.attribute = attribute
    this.value = value
    this.help = help
    this.label = label
    this.htmlAttributes = html
    this.options = options
    this.errors = errors
    this.includeBlank = include_blank
  }
}
export default {
  name: 'BootstrapInput',
  props: {
    input: InputProps,
    scope: String,
    disabled: Boolean
  },
  data() {
    return {
      inputValue: this.input.value,
    }
  },
  computed: {
    inputChanged() {
      return this.input.value?.toString() !== this.inputValue?.toString()
    },
    inputName(){
      return `${this.scope}[${this.input.attribute}]`
    },
    inputId(){
      return `${this.scope.replaceAll(/\[(\w+)\]/g, "_$1")}_${this.input.attribute}`
    },
    inputAttributes() {
      return {
        ...this.input.htmlAttributes,
        class: {
          'input-changed': this.inputChanged,
          'form-control': true,
          'is-invalid': !!this.input.errors,
          [this.input.htmlAttributes.class]: !!this.input.htmlAttributes.class
        },
        disabled: this.disabled,
      }
    }
  }
}
</script>